const throttle = (type, name, obj) => {
  obj = obj || window
  let running = false
  const func = () => {
    if (running) {
      return
    }
    running = true
    requestAnimationFrame(() => {
      obj.dispatchEvent(new CustomEvent(name))
      running = false
    })
  }
  obj.addEventListener(type, func)
}

throttle('resize', 'optimizedResize')

export default {
  data: {
    breakpoint: {},
  },
  mounted() {
    this.optimizeResizeHandler()
    window.addEventListener('optimizedResize', this.optimizeResizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('optimizedResize', this.optimizeResizeHandler)
  },
  methods: {
    optimizeResizeHandler() {
      this.breakpoint = this.$setBreakpointByWindow()
    },
  },
}
